<template>
  <el-table-column v-bind="$attrs"
                   v-on="$listeners" :align="$attrs.align || 'center'">
    <template v-slot="{row}">
      <span v-if="!codes">loading...</span>
      <span v-else-if="!getCodeValue(row)"></span>
      <span class="color-error" v-else-if="!getCode(row)">错误代码</span>
      <span :class="getCode(row).ext1 || ''" v-else>
        {{getCode(row).codeText}}
      </span>
    </template>
  </el-table-column>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";

export default {
  components: {},
  extends: BaseVue,
  props: {
    codeType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      codes: null
    }
  },
  created() {
    this.postForm("/code-item/map", {
      codeType: this.codeType
    }).then(dr=>{
      this.codes = dr.bean;
    });
  },
  methods: {
    getCodeValue(row) {
      let props = this.$attrs.prop.split(".");
      let codeValue = row;
      for(let p of props) {
        codeValue = codeValue[p];
      }
      return codeValue;
    },
    getCode(row) {
      let codeValue = this.getCodeValue(row);
      return this.codes[codeValue];
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/css/variables";
</style>